import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { SupplierOrderResource } from "@exonn/js-sdk";

export const module: ModuleOptions<SupplierOrderResource> = {
  resource: ResourceEnum.SupplierOrder,
  bigIcon: <i className="icon-20-selling" />,
  smallIcon: <i className="icon-15-selling" />,

  disableDelete: true,
  disableEdit: true,
  disableCreate: true,

  tabs: {
    edit: {
      titleProp: "order_number",
    },
  },
};
